(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["storytime-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ---------- Shared lightbox (single instance per page) ---------- */
  var lightbox = null;

  function buildLightbox() {
    if (lightbox) return lightbox;
    var overlay = document.createElement('div');
    overlay.className = 'storytime-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="storytime-lightbox__dialog">' +
        '<button type="button" class="storytime-lightbox__close" aria-label="Close">&times;</button>' +
        '<video class="storytime-lightbox__video" controls playsinline preload="metadata"></video>' +
      '</div>';
    document.body.appendChild(overlay);

    var video = overlay.querySelector('.storytime-lightbox__video');
    var closeBtn = overlay.querySelector('.storytime-lightbox__close');

    function close() {
      overlay.classList.remove('is-open');
      try { video.pause(); } catch (e) {}
      video.removeAttribute('src');
      video.load();
      document.documentElement.style.overflow = '';
    }
    function open(src) {
      video.src = src;
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var p = video.play();
      if (p && p.catch) { p.catch(function () {}); }
    }

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    lightbox = { open: open, close: close };
    return lightbox;
  }

  /* ---------- Slider behavior ---------- */
  function initSlider(section) {
    if (section.dataset.stReady === '1') return;
    section.dataset.stReady = '1';

    var viewport = section.querySelector('[data-storytime-viewport]');
    var track = section.querySelector('[data-storytime-track]');
    var prev = section.querySelector('[data-storytime-prev]');
    var next = section.querySelector('[data-storytime-next]');
    if (!viewport || !track) return;

    function step() {
      var card = track.querySelector('.storytime-card');
      if (!card) return viewport.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap, 10) || 32;
      var cardW = card.getBoundingClientRect().width + gap;
      var perPage = Math.max(1, Math.floor(viewport.clientWidth / cardW));
      return perPage * cardW;
    }

    function update() {
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var x = viewport.scrollLeft;
      if (prev) prev.hidden = x <= 2;
      if (next) next.hidden = x >= maxScroll - 2;
    }

    if (next) next.addEventListener('click', function () { viewport.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { viewport.scrollBy({ left: -step(), behavior: 'smooth' }); });
    viewport.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);

    // Card clicks -> lightbox
    section.querySelectorAll('[data-storytime-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-st-video');
        if (src) buildLightbox().open(src);
      });
    });

    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-storytime-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-storytime-slider]');
    if (sec) { sec.dataset.stReady = ''; initSlider(sec); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
